module.exports = __webpack_public_path__ + "static/media/crop.fec4d57f.svg";